import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/hooks';
import { invoiceState, listInvoice } from '../invoiceSlice';
import { InvoiceDisplay } from '../models/Invoice.interface';


export const useInvoice = (): [boolean, InvoiceDisplay[]] => {
    const dispatch = useAppDispatch();
    const { invoices, isLoading, isSuccess } = useAppSelector(invoiceState);
    useEffect(() => {
        if (!isLoading && !isSuccess) {
            dispatch(listInvoice());
        }
    }, [isLoading, isSuccess, dispatch]);

    return [isLoading, invoices]
}